import { useContext } from 'react';
import { ToastContext } from '../../components/toast/context/toast-context';

export const useToast = () => {
    const toastRef = useContext(ToastContext);

    if (!toastRef) {
        throw new Error('useToast must be used within a ToastProvider');
    }

    const showSuccess = (
        options: { detail?: string, summary?: 'Success', content?: () => JSX.Element, }
    ) => {
        toastRef.current?.show({
            severity: 'success',
            summary: options.summary,
            detail: options.detail,
            life: 3000,
            content: options.content,
        });
    };

    const showError = (
        options: { detail?: string, summary?: 'Error', }
    ) => {
        toastRef.current?.show({
            severity: 'error',
            summary: options.summary,
            detail: options.detail,
            life: 4000,
        });
    };

    const showInfo = (
        options: { detail?: string, summary?: 'Info', }
    ) => {
        toastRef.current?.show({
            severity: 'info',
            summary: options.summary,
            detail: options.detail,
            life: 3000,
        });
    };

    return {
        showSuccess,
        showError,
        showInfo,
    };
};